import { UseFormRegisterReturn, FieldError } from "react-hook-form";

export type FormValues = Record<string, string>;

export interface ErrorObj {
  errorCode: string;
  errorMsg: string;
  status: string;
  timestamp: string;
}

export interface LocationState {
  from: {
    pathname: string;
  };
}

export type TData = {
  [key: string]: string | number | object | null | undefined | React.ReactNode;
};

export interface InputObj {
  isInvalid: boolean;
  name: string;
  register: UseFormRegisterReturn;
  type: string;
  label: string;
  options?: Record<"value" | "name", string>[];
  error?: FieldError;
  size?: string;
  placeholder?: string;
  helperMessage?: string;
  defaultValue?: string | number | readonly string[] | undefined;
  onChange?: (
    values:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
}

export type SubNav = {
  name: string;
  path: string;
  icon: React.ReactNode;
};

export type LoggedInUser = {
  firstName: string;
  lastName: string;
  locale: string;
  mobileNumber: string;
  role?: string;
  roles: { component: string; role: string }[];
  userType: string;
  userSubType: string;
  _id: string;
};

export type Position = "static" | "relative" | "absolute" | "sticky" | "fixed";
export type TextAlign =
  | "left"
  | "right"
  | "center"
  | "justify"
  | "initial"
  | "inherit";
export type TextTransform =
  | "none"
  | "capitalize"
  | "uppercase"
  | "lowercase"
  | "initial"
  | "inherit";

export const COLUMN_TYPES = Object.freeze({
  DATE: "Date",
  MOBILE: "Mobile",
  VALUE: "DeliveryPlanValue",
  AMOUNT: "Amount",
  INVOICE: "Invoice",
  NAME: "Name",
  FEEDBACK: "feedback",
  MOBILE_WITH_SIZE: "mobile_with_size",
  FIRST_NAME_LAST_NAME_COMBINE: "combination",
  FULLNAME: "fullName",
  ACTIONS: "actions",
});

// GaraazRadioSelector Types
export interface UploadModeTooltip {
  title?: string;
  description: string;
  useWhen?: string;
  example?: string[];
}

export interface UploadModeOption {
  value: string;
  label: string;
  subtext?: string;
  icon?: React.ReactNode;
  tooltip?: UploadModeTooltip;
}

export interface UploadModeCardProps {
  option: UploadModeOption;
  isSelected: boolean;
  onSelect: () => void;
  cardHeight?: string; // optional customization
}

export interface UploadModeSelectorProps {
  options: UploadModeOption[];
  value: string;
  onChange: (value: string) => void;
  cardHeight?: string;
  wrapperProps?: any;
  mainTitle?: string;
}

//GaraazInputSearch
export interface GenericSortOption<T> {
  label: string;
  value: T;
}

export interface GenericSearchAndSortBarProps<T> {
  searchInput: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sortField: T;
  setSortField: (field: T) => void;
  sortOptions: GenericSortOption<T>[];
  placeholder?: string;
  showSortControl?: boolean;
  extraComponent?: React.ReactNode;
}

export interface BadgeWithTooltipProps {
  icon?: React.ReactNode;
  label?: string;
  tooltip?: string;
  className?: any;
}
export interface MedalIconProps {
  rank: 1 | 2 | 3;
  size?: number;
}

// GaraazCollectpaymentModal

export enum CollectedBy {
  SUPPLIER = "SUPPLIER",
  GARAAZ = "GARAAZ",
}
export interface Collector {
  id: string;
  firstName: string;
  lastName?: string;
  collectedBy?: CollectedBy;
}

export enum InvoiceType {
  DELIVERY = "DELIVERY"
}

export interface OrderDetails {
  orderNo: string;
  invoiceNo?: string | null;
  invoiceType?: InvoiceType;
  customerAdvancePayment?: number;
  invoiceAmount?: number;
}

export interface PaymentModeOption {
  value: string;
  label: string;
  prefix?: string;
  disabled?: boolean;
  hidden?: boolean;
}

export enum PaymentMode {
  HARD_CASH = "Hard Cash",
  UPI = "UPI",
  BANK_TRANSFER = "Bank Transfer",
  CARD = "Card",
  CHEQUE = "Cheque",
  CREDIT_NOTE = "Credit Note",
  ADVANCE_PAYMENT = "Advance Payment",
}

export interface ReceivePaymentModalProps {
  auth: { authToken: string };
  isOpen: boolean;
  onClose: () => void;
  collector: Collector;
  orderDetails: OrderDetails;
  onCollectPayment: (payload: any) => Promise<any>;
  paymentModes?: (Partial<PaymentModeOption> & { value: string })[];
  notification: (options: { description: string; status: string }) => void;
  title?: string;
  selectPlaceholder?: string;
  maxNotesLength?: number;
  onPaymentSuccess?: () => void;
}

export const defaultPaymentModes: PaymentModeOption[] = [
  { value: PaymentMode.HARD_CASH, label: "Hard Cash", prefix: "💵" },
  { value: PaymentMode.UPI, label: "UPI", prefix: "📱" },
  { value: PaymentMode.BANK_TRANSFER, label: "Bank Transfer", prefix: "🏦" },
  { value: PaymentMode.CARD, label: "Card", prefix: "💳" },
  { value: PaymentMode.CHEQUE, label: "Cheque", prefix: "📄" },
  { value: PaymentMode.CREDIT_NOTE, label: "Credit Note", prefix: "📝" },
];